import React from 'react';
import { useTranslation } from 'react-i18next';
const CateringBasicInfo = (props) => {
    const { catering } = props
    const { t } = useTranslation();

    return (
            <div className='grid'>
                <div className='col-12 mt-3'>
                    <h4>{t('basicInformation')}</h4>
                </div>
                <div className='col-4 p-3 border-bottom-1 border-300 '><i className='pi pi-info-circle text-lg'></i> {t('companyName')}</div>
                {catering?.name && <div className='col-8 font-bold p-3 border-bottom-1 border-300'>{catering.name}</div>}
                <div className='col-4 p-3 border-bottom-1 border-300'><i className='pi pi-question-circle text-lg'></i> {t('description')}</div>
                {catering?.description && <div className='col-8 font-bold p-3 border-bottom-1 border-300'>{catering.description}</div>}
                <div className='col-4 p-3 border-bottom-1 border-300'><i className='pi pi-home text-lg'></i> {t('address')}</div>
                {catering?.addressCountry && <div className='col-8 font-bold p-3 border-bottom-1 border-300'>{catering.addressCountry + ", " + catering?.addressCity + ", " + catering?.addressStreetAndNumber}  </div>}
                <div className='col-12 mt-3'>
                    <h4>{t('contactData')}</h4>
                </div>
                <div className='col-4 p-3 border-bottom-1 border-300'><i className='pi pi-envelope text-lg'></i> {t('email')}</div>
                {catering?.email && <div className='col-8 font-bold p-3 border-bottom-1 border-300'>{catering.email}</div>}
                <div className='col-4 p-3 border-bottom-1 border-300'><i className='pi pi-phone text-lg'></i> {t('phone')}</div>
                {catering?.phone && <div className='col-8 font-bold p-3 border-bottom-1 border-300'>{catering.phone}</div>}
            </div>
    )
}


export default CateringBasicInfo